import { SubscriptionSource } from '@/types'

export const SUBSCRIPTIONS_SOURCES: Record<SubscriptionSource, string> = {
  [SubscriptionSource.Footer]: 'Форма «Footer»',
  [SubscriptionSource.Popup]: 'Popup-баннер',
  [SubscriptionSource.Order]: 'Заказ',
  [SubscriptionSource.Product]: 'Уведомить о поступлении',
  [SubscriptionSource.Loyalty]: 'Регистрация в системе лояльности',
}

export const COUPONS_ACTIVITY_OPTIONS = [
  { name: 'Все', value: null },
  { name: 'Активные', value: true },
  { name: 'Неактивные', value: false },
]

export const COUPONS_TYPE_OPTIONS = [
  { name: '₽', value: true },
  { name: '%', value: false },
]
export const GIFTCARD_TYPE_OPTIONS = [
  { name: 'Электронный', value: 'online' },
  { name: 'Физический', value: 'offline' },
]
